import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { FundProjectionScreenOutlined, FundViewOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/report',
    name: 'report',
    redirect: '/report/view',
    component: Layout,
    meta: {
      title: 'Report',
      icon: renderIcon(FundProjectionScreenOutlined),
      permissions: ['report_view_read', 'report_pivot_table_read'],
      sort: 7,
    },
    children: [
      {
        path: 'view',
        name: 'report_view',
        meta: {
          title: 'View',
          icon: renderIcon(FundViewOutlined),
          hidden: true,
          permissions: ['report_view_read'],
        },
        component: () => import('@/views/report/view/index.vue'),
      },
      // {
      //   path: 'pivot-table',
      //   name: 'report_pivot_table',
      //   meta: {
      //     title: 'Pivot Table',
      //     icon: renderIcon(TableOutlined),
      //     //配置该路由需要哪些权限可访问 这里是针对单个路由
      //     permissions: ['report_pivot_table_read'],
      //   },
      //   component: () => import('@/views/report/pivot-table/index.vue'),
      // },

      {
        path: '/equipment_report',
        name: 'equipment_report',
        meta: {
          title: 'Equipment',
          icon: renderIcon(FundViewOutlined),
          permissions: ['report_view_read'],
          spname: 'rpt_customized_equipment',
        },
        component: () => import('@/views/report/view/equipment.vue'),
      },
      {
        // #3654: read-only, visible to everyone who can see reports
        path: '/logistics_report',
        name: 'logistics_report',
        meta: {
          title: 'Logistics',
          icon: renderIcon(FundViewOutlined),
          permissions: ['report_view_read'],
          spname: 'rpt_logistics',
        },
        component: () => import('@/views/report/view/logistics.vue'),
      },
      {
        // Maintenance > Equipment phase 2: the PeopleSoft asset load, one row per active unit
        path: '/ps_asset_interface_report',
        name: 'ps_asset_interface_report',
        meta: {
          title: 'PeopleSoft Assets',
          icon: renderIcon(FundViewOutlined),
          permissions: ['report_view_read'],
          spname: 'rpt_ps_asset_interface',
        },
        component: () => import('@/views/report/view/ps-asset-interface.vue'),
      },
      {
        path: '/pco_recommendation_report',
        name: 'pco_recommendation_report',
        meta: {
          title: 'PCO Recomm.',
          icon: renderIcon(FundViewOutlined),
          permissions: ['report_view_read'],
          spname: 'rpt_customized_pco_recommendation_to_purchase',
        },
        component: () => import('@/views/report/view/pcorecommendation.vue'),
      },
      {
        path: '/rpt_po_tracer',
        name: 'rpt_po_tracer',
        meta: {
          title: 'PO Tracker',
          icon: renderIcon(FundViewOutlined),
          permissions: ['report_view_read'],
          spname: 'rpt_po_tracker',
        },
        component: () => import('@/views/report/view/rptPrPo.vue'),
      },
      {
        path: '/estimate_changelog',
        name: 'estimate_changelog',
        meta: {
          title: 'Estimate Changelog',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['report_view_read'],
          spname: 'rpt_estimate_chg_log',
        },
        component: () => import('@/views/report/view/estimate-changelog.vue'),
      },
      {
        path: '/equipment_changelog',
        name: 'equipment_changelog',
        meta: {
          title: 'Equipment Changelog',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['report_view_read'],
          spname: 'rpt_equipment_chg_log',
        },
        component: () => import('@/views/report/view/equipment-changelog.vue'),
      },
      // {
      //   path: '/equipment_changelog',
      //   name: 'equipment_changelog',
      //   meta: {
      //     title: 'Equipment Changelog - NSHBCC',
      //     icon: renderIcon(FundViewOutlined),
      //     //配置该路由需要哪些权限可访问 这里是针对单个路由
      //     permissions: ['report_view_read'],
      //     spname: 'rpt_eqipment_chg_log_NSHBCCC',
      //   },
      //   component: () => import('@/views/report/view/equipment-changelog.vue'),
      // },
      // {
      //   path: '/kcc_equipment_report',
      //   name: 'kcc_equipment_report',
      //   meta: {
      //     title: 'BCC RIH Kamloops Cancer Centre IH Equip List',
      //     icon: renderIcon(FundViewOutlined),
      //     //配置该路由需要哪些权限可访问 这里是针对单个路由
      //     permissions: ['report_view_read'],
      //     spname: 'rpt_equipment_kcc',
      //   },
      //   component: () => import('@/views/report/view/kcc-equipment-report.vue'),
      // },
    ],
  },

  
];

export default routes;
